var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature col-xl-4 col-lg-6 col-md-4 col-6"},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.feature.feature))])])
}
var staticRenderFns = []

export { render, staticRenderFns }